import * as Sentry from '@sentry/browser';
import { maskSearchParam } from './helpers/common';

if (
  process.env.REACT_APP_SENTRY_DSN != null &&
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_RELEASE != null
) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    release: process.env.REACT_APP_RELEASE,
    beforeSend(e) {
      const currentReferer = e.request.headers.Referer;
      const currentUrl = e.request.url;

      if (typeof currentReferer === 'string') {
        e.request.headers.Referer = maskSearchParam(
          currentReferer,
          'sign',
          '****',
          4
        );
      }

      if (typeof currentUrl === 'string') {
        e.request.url = maskSearchParam(currentUrl, 'sign', '****', 4);
      }

      return e;
    },
  });
}
